import { useQuery } from 'react-query';

import { CategoriesData } from '../types/categories';
import { fetchCategoriesAndCourses } from '../utils/categories';

export const useCategories = () => {
  return useQuery<CategoriesData, Error>(
    ['categories'],
    fetchCategoriesAndCourses
  );
};
